module.exports = __webpack_public_path__ + "static/media/logo.95826b05.svg";